import React from "react";

const Permission = ()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" id="lock"><path fill="none" d="M0 0h24v24H0z"></path><g fill="#757575"><path d="M17 11H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3v1h2V7c0-2.757-2.243-5-5-5S7 4.243 7 7v4c-1.103 0-2 .896-2 2v7c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-7c0-1.104-.897-2-2-2zM7 20v-7h10l.001 7H7z"></path><circle cx="12" cy="16.5" r="1.5"></circle></g></svg>
            )
}

export default Permission;